/** Deduplicate GPS allocation / top-10 rows (FE mirror of server helper). */

export type GpsAllocationRow = { label: string; value: number; color?: string };

function toNumber(value: unknown): number | null {
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  if (typeof value === 'string') {
    const n = Number(value.replace(',', '.').replace('%', '').trim());
    return Number.isFinite(n) ? n : null;
  }
  return null;
}

function toSortNumber(value: unknown): number {
  return toNumber(value) ?? 0;
}

export function dedupeAllocationByLabel(
  rows: Array<{ label?: string | null; value?: unknown; color?: string }> | null | undefined
): GpsAllocationRow[] {
  if (!Array.isArray(rows) || rows.length === 0) return [];
  const seen = new Set<string>();
  const out: GpsAllocationRow[] = [];
  for (const row of rows) {
    const label = String(row?.label ?? '').trim();
    const key = label.toLowerCase();
    const value = toNumber(row?.value);
    if (!key || value === null || seen.has(key)) continue;
    seen.add(key);
    out.push({
      label,
      value,
      ...(row.color ? { color: row.color } : {}),
    });
  }
  return out.sort((a, b) => b.value - a.value);
}

export function dedupeTop10ByName<T extends { name?: string | null; percentage?: string | number | null }>(
  rows: T[] | null | undefined
): Array<T & { name: string }> {
  if (!Array.isArray(rows) || rows.length === 0) return [];
  const seen = new Set<string>();
  const out: Array<T & { name: string }> = [];
  for (const row of rows) {
    const name = String(row?.name ?? '').trim();
    const key = name.toLowerCase();
    if (!key || seen.has(key)) continue;
    seen.add(key);
    out.push({ ...row, name });
  }
  return out.sort((a, b) => toSortNumber(b.percentage) - toSortNumber(a.percentage));
}
